<template>
  <!-- <div>
    <el-col :sapn="24">
      <div class="titleTop">
        <h5 style="margin: 0;">
          Data statistics
        </h5>
      </div>
    </el-col>
    <el-col :sapn="24"> -->
  <div id="sankit" class="sankitChart" v-loading="fullscreenLoading"></div>
  <!-- </el-col>
  </div> -->
</template>

<script>
import { baseConfig, pathConfig } from '../assets/util/baseConfig'

export default {
  data() {
    return {
      baseConfig: baseConfig,
      pathConfig: pathConfig,
      fullscreenLoading: true
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      let _this = this

      let requestParams = {}

      requestParams.Project = _this.baseConfig.project

      const successCallBack = (res) => {
        if (res) {
          this.$nextTick(() => {
            if (res.data) {
              _this.drawSankit(res.data)
            }
          })
        }
      }

      const errorCallBack = (res) => {
        if (res && res.status === 200) {
        } else if (res) {
          _this.showAlert('error', res.msg)
        }
      }

      this.$post(
        this.pathConfig.apiPath + this.pathConfig.toolsPath + 'ParallelPlot/',
        requestParams,
        successCallBack,
        errorCallBack
      )
    },
    drawSankit(data) {
      let divAppend = document.getElementById('sankit')

      if (divAppend && data) {
        divAppend.innerHTML = data.div

        if (data.script) {
          let scriptContent = document.createElement('script')

          scriptContent.innerHTML = data.script
          document.body.append(scriptContent)

          this.fullscreenLoading = false
        }
      }
    }
  }
}
</script>

<style>
.sankitChart {
  padding-left: 20px;
  padding-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/sankit.vue